
import { defineComponent, reactive } from 'vue'
import LoginPanel from './cpns/login-panel.vue'
export default defineComponent({
  name: 'login',
  setup() {
    return {}
  },
  components: {
    LoginPanel
  }
})
